<template>
  <div>
    <div class="text-xs-right">
      <v-btn v-if="selectedBot.pagetype == 'enterprise' || $store.getters.getPackage == 'premium'" color="primary" @click="openModal" outline>
        <i class="fas fa-exchange-alt mr-1"></i>
        {{$t('Transfer')}}
      </v-btn>
      <v-btn v-else color="primary" outline>
        <i class="fas fa-exchange-alt mr-2"></i>
        {{ $t('Transfer') }}
        <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
      </v-btn>

      <v-dialog v-model="showTransfer" scrollable max-width="1000px">
        <v-card>
          <v-card-title>
            <v-layout wrap row class="mb-0">
              <v-flex xs12 sm5 class="text-xs-center">
                <v-menu offset-y open-on-hover offset-overflow max-height="200">
                  <template v-slot:activator="{ on }">
                    <v-btn outline round color="primary" v-on="on">
                      <template v-if="currentPage">
                        <div
                          class="text-truncate"
                          style="display:inline-block; word-break: break-all;max-width: 150px;    vertical-align: middle;"
                        >{{currentPage.name}}</div>
                      </template>
                      <template v-else>{{$t('Select page')}}</template>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in optionBotlist"
                      :key="index"
                      @click="selectBot(item)"
                    >
                      <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2 class="text-xs-center">
                <i class="fas fa-arrow-right hidden-xs-only mt-3"></i>
                <i class="fas fa-arrow-down hidden-sm-and-up mt-2"></i>
              </v-flex>

              <v-flex xs12 sm5 class="text-xs-center pt-3">{{selectedBot.pagename}}</v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;" class="pa-0">
            <div class="mt-2 mb-2" v-if="loading">
              <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
            </div>
            <div
              class="text-xs-center mt-4 mb-4"
              v-else-if="comparelist.length == 0"
            >{{$t('Choose page to transfer')}}</div>
            <div class="pb-2" v-else>
              <v-list-tile style="background: #eee;">
                <v-list-tile-action @click.prevent="toggleSelect(selectAll)">
                  <v-checkbox v-model="selectAll" color="primary"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content
                  @click.prevent="selectAll = !selectAll;toggleSelect(selectAll)"
                >
                  <v-list-tile-title>{{$t('Select All')}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

              <template v-for="(compare,index) in comparelist">
                <v-list-tile :key="'compare_'+ compare.id" @click>
                  <v-list-tile-action>
                    <v-checkbox v-model="compare.selected" color="primary"></v-checkbox>
                  </v-list-tile-action>

                  <v-list-tile-content @click.prevent="compare.selected = !compare.selected">
  <!--                   <v-list-tile-title>
                      <template
                        v-if="compare.name == '{default}'"
                      >{{$t('Default Shop')}}</template> -->
<!--                       <template
                        v-else-if="compare.name == '{default_comment_to_inbox}'"
                      >{{$t('More Comment to Inbox')}}</template>
                      <template
                        v-else-if="compare.name == '{welcome}'"
                      >{{$t('Welcome Message')}}</template> -->
                      <template >{{compare.name}}</template>
                    </v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action
                    class="text-xs-center"
                    @click.prevent="compare.selected = !compare.selected"
                  >
                    <v-list-tile-action-text
                      v-if="!compare.page2"
                      style="margin: auto;"
                    >{{$t('Insert2')}}</v-list-tile-action-text>
                    <v-list-tile-action-text
                      v-else
                      style="margin: auto;"
                      class="info--text"
                    >{{$t('Replace2')}}</v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="index + 1 < comparelist.length" :key="index" class="mt-2"></v-divider>
              </template>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outline color="grey" @click="showTransfer = false">{{$t('cancel')}}</v-btn>
            <v-btn
              outline
              color="primary"
              :disabled="isSelected == 0"
              @click="saveTransfer"
            >{{$t('Save')}}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  data: () => {
    return {
      showTransfer: false,
      test: false,
      currentPage: null,
      comparelist: [],
      loading: true,
      selectAll: false
    }
  },
  components: {
    ModalDialog,
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    optionBotlist: function() {
      let options = []
      let vm = this
      $.each(vm.botlist, function(index, val) {
        if (val.pageid != vm.selectedBot.pageid) {
          options.push({ name: val.pagename, value: val.pageid })
        }
      })

      return options
    },
    isSelected: function() {
      return this.comparelist.filter(function(el) {
        return el.selected
      }).length
    }
  },
  methods: {
    openModal: function() {
      var vm = this
      vm.showTransfer = true
      if (vm.currentPage) {
        vm.loading = true
        vm.compareShopService(vm.currentPage).then(
          function() {
            vm.loading = false
          },
          function() {
            vm.loading = false
          }
        )
      } else {
        vm.loading = false
      }
    },
    selectBot(page) {
      var vm = this
      vm.currentPage = page
      vm.loading = true
      vm.compareShopService(vm.currentPage).then(
        function() {
          vm.loading = false
        },
        function() {
          vm.loading = false
        }
      )
    },
    compareShopService: function(page) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid1: page.value,
          pageid2: vm.selectedBot.pageid
        }
        api.getcompareshopservice(data, function(error, response) {
          if (error) {
            reject(error)
          }
          vm.comparelist = []
          if (response.data) {
            response.data = response.data.sort(function(a, b) {
              var nameA = a.name.toLowerCase()
              var nameB = b.name.toLowerCase()
              if (a.name[0] === '{' && a.name[a.name.length - 1] === '}') {
                return 1
              }
              if (b.name[0] === '{' && b.name[b.name.length - 1] === '}') {
                return -1
              }
              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }
            })
            response.data.map(function(el) {
              let compare = el
              compare.selected = true
              vm.comparelist.push(compare)
            })
          }
          resolve()
        })
      })
    },
    saveTransfer: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Are you sure you want to transfer the products?'),
          text: vm.$t(
            'Once you confirmed, you cannot go back and the existing products will be replaced.'
          ),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var intentsid = []

            if (vm.comparelist) {
              vm.comparelist.map(function(el) {
                if (el.selected) {
                  intentsid.push(el.id)
                }
              })
            }

            if (intentsid.length == 0) {
              return false
            }

            var data = {
              pageid1: vm.currentPage.value,
              pageid2: vm.selectedBot.pageid,
              categoriesid: intentsid.join(',')
            }

            vm.$store.dispatch('loading')
            api.transfershopservice(data, function(error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                vm.$swal.fire({
                  title: vm.$t('Transfer products unsuccessful'),
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                return false
              }
              vm.showTransfer = false
              vm.$store.dispatch('loading')
              vm.$swal
                .fire({
                  title: vm.$t('Transfer products successful'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                .then(function(result) {
                  if (result.value) {
                    location.reload()
                  }
                })
            })
          }
        })
    },
    toggleSelect: function(value) {
      var vm = this
      if (vm.comparelist) {
        vm.comparelist.map(function(compare, index) {
          vm.comparelist[index].selected = value
        })
      }
    }
  },
  watch: {
    isSelected: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectAll = newVal == this.comparelist.length
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/TransferShop.vue